const React = require('react');
const { useParams } = require('react-router-dom');

const Menu = require('./Menu');
const dataHelper = require('../../dataHelper');

async function fetchMenu() {
  let menu = []
  try {
    menu = await (await dataHelper.fetchData('menus.json')).json();
    const articles = await (await dataHelper.fetchData('articles.json')).json();
    menu.forEach((item) => {
      item.children = articles[item.id] || [];
    });
  }
  catch(e) {
    console.error('Not able to fetch menu', e);
  }
  return menu
}

const GuideMenu = (props) => {
  const [menu, setMenu] = React.useState([]);
  const { folder } = useParams();

  React.useEffect(() => {
    fetchMenu()
      .then(m => setMenu(m))
      .catch(e => console.error('Not able to fetch menu'));
  }, []);

  menu.forEach((item) => {
    item.active = item.id === folder;

    // if active item has children, show them in the menu
    if (item.active && item.children?.length) {
      item.items = item.children.map(i => ({ name: i.title, link: '/doc/' + folder + '/' + i.id }));
    }
    else item.items = null
  });

  const { openAll } = props;
  return <Menu name="Guides" sections={menu} openAll={openAll} />;
};

module.exports = GuideMenu;
